export class SubCompanyLicenseStateApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSubCompanyLicenseState({ subCompanyId }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/state-licenses`);
  }

  async createSubCompanyLicenseState({ subCompanyId, ...body }) {
    return this.#http.post(`/api/sub-companies/${subCompanyId}/state-licenses`, body);
  }

  async editSubCompanyLicenseState({ subCompanyId, licenseId, ...body }) {
    return this.#http.put(`/api/sub-companies/${subCompanyId}/state-licenses/${licenseId}`, body);
  }

  async deleteSubCompanyLicenseState({ subCompanyId, licenseId }) {
    return this.#http.delete(`/api/sub-companies/${subCompanyId}/state-licenses/${licenseId}`);
  }
}
